import * as React from "react";
import Ajax from "../../Ajax";
import swal from 'sweetalert';
import TextareaAutosize from 'react-textarea-autosize';

interface IFormProps {
  setForEdit: any
  setClose: any
}
interface MyStates {
  ajaxLoaded: boolean,
  spinner: string
}
export default class NewPlace extends React.Component<IFormProps, MyStates>{

  constructor(props:IFormProps) {
    super(props);

    this.state = {
      ajaxLoaded: false,
      spinner: 'none'
    }
    //this.getData()
  }

  private handleSubmit(e){
    e.preventDefault();

    this.setState({
      spinner: 'flex',
    }, () => {
      var ajax = new Ajax(window.location.origin+ '/reservatio/szallashelyek/addNew');
      ajax.doPost('new_place', true).then((response) => {
        if( response.status !== undefined && response.status === 'success' ){
          swal({
            title: "Siker!",
            text: "A szállás létrehozva!",
            icon: "success",
          });
          this.props.setForEdit(response.place.id)
        } else {
          swal({
            title: "Hiba történt!",
            text: "A szállás nem lett hozzáadva!",
            icon: "error",
          });
        }
      })
    })
  }

  private close(){
    this.props.setClose(true)
  }

  public render() {
    return (
    <>
    <div className="box">
      <div className="box-header">
        <h3 className="box-title">Új szállás hozzáadása</h3> 
        <button type="button" style={{marginTop:"-3px"}} onClick={() => this.close()} className="btn btn-xs pull-right btn-danger"><i className="fa fa-window-close"></i></button> 
      </div>
      <div className="box-body" style={{position: 'relative'}}>
        <div className="spinner-fill" style={{display: this.state.spinner}}>
          <div className="spinner-border" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
        <form id="new_place" onSubmit={(e) => this.handleSubmit(e)}>
          <div className="row">
            <div className="col-md-6 form-group">
              <input type="text" name="name" className="form-control" placeholder="Megnevezés" required />
            </div>
            <div className="col-md-6 form-group">
              <input type="text" name="code" className="form-control" placeholder="Kód" required />
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 form-group">
              <TextareaAutosize name="description" className="form-control" placeholder="Leírás"/>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 form-group">
              <div className="input-group">
                <span className="input-group-addon height-34px">
                  Akadálymentesített
                </span>	
                <span className="input-group-addon">
                  <input type="checkbox" name="accessibility" />
                </span>	
              </div>
            </div>
            <div className="col-md-6 form-group">
              <div className="input-group">
                <span className="input-group-addon width-100px">
                  Férőhely:
                </span>	
                <input type="number" name="capacity" className="form-control" required />
                <span className="input-group-addon bg-white">
                  ágy
                </span>	
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 form-group">
              <div className="input-group">
                <span className="input-group-addon">
                Minimum foglalható:
                </span>	
                <input type="number" name="minimum_nights" className="form-control" required />
                <span className="input-group-addon bg-white">
                éj
                </span>	
              </div>
            </div>
            <div className="col-md-6 form-group">
              <div className="input-group">
                <span className="input-group-addon width-100px">
                  Napidíj:
                </span>	
                <input type="number" name="daily_price" className="form-control" required />
                <span className="input-group-addon bg-white">
                  Ft
                </span>	
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 form-group">
              <div className="input-group">
                <span className="input-group-addon width-150px">
                  Státusz:
                </span>	
                <select name="status" className="form-control">
                  <option value="active">Aktív</option>
                  <option value="inactive">Inaktív</option>
                </select>
              </div>
            </div>
            <div className="col-md-6 form-group">
                <div className="input-group">
                  <span className="input-group-addon height-34px">
                    Kétszeres szorzó:
                  </span>	
                  <span className="input-group-addon">
                    <input type="checkbox" name="double_multiplier" />
                  </span>	
                </div>
              </div>
            <div className="col-md-6 form-group">
              <div className="input-group">
                  <span className="input-group-addon width-150px">
                    Szállás típus:
                  </span>
                <select name="storey" className="form-control">
                  <option value="downstairs">Földszint</option>
                  <option value="first_floor">1. emelet</option>
                  <option value="tent_site">Sátorhely</option>
                </select>
              </div>
            </div>
          </div>
          <div className = "row">
            <div className="col-md-6 form-group">
              <div className="input-group">
                <button className="btn btn-success btn-block">Létrehozás</button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    </>)
  }
}